import { Currency } from "@redotech/money/currencies";
import { z } from "zod/v4";

const MoneySchema = z.object({
  amount: z.string(),
  currencyCode: z.enum(Currency),
});
const PriceSetSchema_ = z.object({
  shopMoney: MoneySchema,
  presentmentMoney: MoneySchema,
});

export const PriceSetSchema: z.ZodType<PriceSet> = PriceSetSchema_;
export interface PriceSet extends z.infer<typeof PriceSetSchema_> {}
